import { Injectable } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { Imports } from '../_models/import';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';

@Injectable({
   providedIn: 'root',
})
export class Import2Service {
   baseUrl = environment.apiUrl;
   ImportSelected = new Subject<Imports>();
   constructor(private http: HttpClient) {}

   changeImportState(i: Imports) {
      this.ImportSelected.next(i);
   }
   export(OnlyTemplate: boolean, url: string): Observable<Blob> {
      // tslint:disable-next-line:max-line-length
      return this.http.get(this.baseUrl + url + OnlyTemplate, {
         responseType: 'blob',
      });

      // 'user/export/'
   }
}
